var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"auth-pages"},[_c('div',{staticClass:"header-auth position-relative ma-4 pb-16 pt-16 border-radius-xl"}),_c('v-container',{staticClass:"mt-n16 pb-0"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }